import React from 'react';
import svgLogosFamilles from '../../images/familles-equipment.svg';
import fontAwesomeSolidSvg from '../../images/solid.svg';

export const SvgIcon = (props) => {
  const { name, color, size, type, style } = props

  return (
    <>
      {type === 'solid' &&
        <svg width={size} viewBox="0 0 1000 500" fill={color} style={style}>
          <use href={fontAwesomeSolidSvg + `#${name}`} />
        </svg>
      }
      {type !== 'solid' &&
        <svg width={size} viewBox="0 0 1000 500" fill={color} stroke={color} style={style}>
          <use href={svgLogosFamilles + `#${type}`} />
        </svg>
      }
    </>
  );
};